<template>
  <tr class="table-row" :class="{'table-row--parent': row[childDataKey]}">
    <slot></slot>
  </tr>
</template>

<script>
export default {
  props: {
    row: {
      type: Object,
      default: () => {},
    },
    rowId: {
      type: [String, Number],
      default: '',
    },
    rowData: {
      type: Array,
      default: () => [],
    },
    childDataKey: {
      type: String,
      default: 'childData',
    },
  },
  data() {
    return {};
  },
  provide() {
    return {
      item: this,
    };
  },
};
</script>
